import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "text-right mb-4" }
const _hoisted_2 = {
  filter: "name",
  sort: "name"
}
const _hoisted_3 = {
  filter: "order",
  sort: "order"
}
const _hoisted_4 = {
  filter: "useShoppingCart",
  filterType: "checkbox",
  sort: "useShoppingCart"
}
const _hoisted_5 = {
  filter: "minProductLevelRequired",
  sort: "minProductLevelRequired"
}
const _hoisted_6 = {
  filter: "maxProductLevelRequired",
  sort: "maxProductLevelRequired"
}
const _hoisted_7 = {
  filter: "isUpsellCategory",
  filterType: "checkbox",
  sort: "isUpsellCategory"
}
const _hoisted_8 = {
  filter: "disabled",
  filterType: "checkbox",
  sort: "disabled"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { colspan: "99" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onUpdate:modelValue", "onChange"]
const _hoisted_15 = ["onUpdate:modelValue", "onChange"]
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "btn btn-primary",
        to: "/shopConfig/category/0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_localized_text, {
            localizedKey: "Nuova categoria",
            text: "Nuova categoria"
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.categories
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ordine",
                text: "Ordine"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Usa carrello",
                text: "Usa carrello"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Min Product Level",
                text: "Min Product Level"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Max Product Level",
                text: "Max Product Level"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Categoria per upsell",
                text: "Categoria per upsell"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Disabilitato",
                text: "Disabilitato"
              })
            ]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createElementVNode("td", _hoisted_11, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                }, null, 8, _hoisted_12), [
                  [_vModelText, item.name]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((item.order) = $event)
                }, null, 8, _hoisted_13), [
                  [_vModelText, item.order]
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(item.useShoppingCart ? "SI" : ""), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(item.minProductLevelRequired), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(item.maxProductLevelRequired), 1)
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-control",
                  "onUpdate:modelValue": ($event: any) => ((item.isUpsellCategory) = $event),
                  onChange: ($event: any) => (_ctx.saveItem(item))
                }, null, 40, _hoisted_14), [
                  [_vModelCheckbox, item.isUpsellCategory]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-control",
                  "onUpdate:modelValue": ($event: any) => ((item.disabled) = $event),
                  onChange: ($event: any) => (_ctx.saveItem(item))
                }, null, 40, _hoisted_15), [
                  [_vModelCheckbox, item.disabled]
                ])
              ]),
              _createElementVNode("td", _hoisted_16, [
                (item.identifier)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm ml-2 btn-warning",
                      onClick: ($event: any) => (_ctx.goToCategory(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Vedi prodotti",
                        text: "Vedi prodotti"
                      })
                    ], 8, _hoisted_17))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary ml-2",
                  onClick: ($event: any) => (_ctx.$router.push('/shopConfig/category/' + item.identifier))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Dettaglio",
                    text: "Dettaglio"
                  })
                ], 8, _hoisted_18),
                (item.identifier)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-sm btn-danger ml-2",
                      onClick: ($event: any) => (_ctx.removeItem(item, i))
                    }, _hoisted_21, 8, _hoisted_19))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}